import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/landing.js";
import { NavMenu } from "./components/Navbar.js";
import { Footer } from "./pages/footer.js";
import { SheVentures } from "./pages/sheVentures.js";
import { OurEthos } from "./pages/OurEthos.js";
import { Experiences } from "./pages/experiences.js";
import { Banner } from "./components/banner.js";
import { ContactUs } from "./pages/contactUs.js";
import { AboutUs } from "./pages/AboutUs.js";
import { Destination } from "./pages/Destination.js";
import { Testimonials } from "./pages/Testimonials.js";
import useWindowDimensions from "./hooks/useWindowDimensions.js";
import { useEffect, useState } from "react";
import { FAQ } from "./pages/FAQ.js";
import { SignatureJourneys } from "./components/SignatureJourneys.js";
import { ProductNew } from "./pages/ProductNew.js";
import AnimatedContent from "./animatedComponents/AnimatedContent.js";

function App() {

  const [joyBannerFontSize, setJoyNowBannerFontSize] = useState("1.8rem");
  const [hideDestinationHeading, setHideDestinationHeading] = useState(false);
  const [increaseProductHeadingIndex, setIncreaseProductHeadingIndex] =
    useState(true);
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (width > 900 && width <= 1200) {
      setJoyNowBannerFontSize("1.8rem");
      return;
    } else if (width > 600 && width <= 900) {
      setJoyNowBannerFontSize("1.6rem");

      return;
    } else if (width <= 600) {
      setJoyNowBannerFontSize("1.3rem");

      return;
    }

    setJoyNowBannerFontSize("1.8rem");
    return;
  }, [width]);

  return (
    <BrowserRouter>
      <NavMenu
        increaseProductHeadingIndex={increaseProductHeadingIndex}
        setIncreaseProductHeadingIndex={setIncreaseProductHeadingIndex}
        setHideDestinationHeading={setHideDestinationHeading}
        hideDestinationHeading={hideDestinationHeading}
      />

      <Routes>

        <Route
          path="/"
          element={
            <>
              <Landing />
              <OurEthos />

              <AnimatedContent>

                <SheVentures />
              </AnimatedContent>
              <AnimatedContent>
                <SignatureJourneys />

              </AnimatedContent>
              <AnimatedContent>
                <Banner
                  heading={
                    <>
                      Our greatest joy comes from the experiences of our travellers{width > 600 && (
                        <>
                          <br /><span className="dash-divider" />
                        </>
                      )}
                      it's what drives our passion.
                    </>
                  }
                  headingStyle={{
                    marginBottom: width < 600 && "0",
                  }}
                  fontSize={joyBannerFontSize}
                  renderIcons={true}
                  backgroundColor={"#97789B"}
                  width={width > 600 ? "65%" : "100%"}
                  style={{
                    alignSelf: "center",
                    height: width > 600 ? "16vh" : "20vh",
                    padding: width < 600 && "1rem"
                  }}
                />

              </AnimatedContent>
              <AnimatedContent>
                <Experiences />

              </AnimatedContent>
              <div style={{ margin: "2rem 0" }}></div>

              <AnimatedContent>
                <Testimonials />
              </AnimatedContent>

              <AnimatedContent>
                <Banner
                  // addLetterSpacing={width  600}
                  heading={"Journey not listed? Let's build it"}
                  fontSize={joyBannerFontSize}
                  renderIcons={true}
                  renderFormButton={true}
                  backgroundColor={"#97789B"}
                  width={"100%"}
                  headingStyle={{
                    marginBottom: 0
                  }}
                  style={{
                    alignSelf: "center",
                    letterSpacing: "0.1rem",
                    height: width < 600 && "18vh",
                    marginTop: width < 600 && "2rem",
                    marginBottom: width < 600 && "2rem"
                  }}
                />

              </AnimatedContent>

            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <AboutUs />
              <Banner
                headingStyle={{
                  margin: width < 600 && "0 0",

                }}
                // addLetterSpacing={width > 600}
                heading={"Travel With Us"}
                fontSize={joyBannerFontSize}
                renderIcons={true}
                renderFormButton={true}
                backgroundColor={"#97789B"}
                width={"100%"}
                style={{
                  alignSelf: "center",
                  height: width < 600 && "18vh",

                }}
              />
            </>
          }
        />
        <Route
          path="/:destination"
          element={
            <>
              <Destination hideDestinationHeading={hideDestinationHeading} />
              <Banner
                heading={"Travel With Us"}
                // addLetterSpacing={width > 600}
                fontSize={joyBannerFontSize}
                renderIcons={true}
                renderFormButton={true}
                backgroundColor={"#97789B"}
                headingStyle={{
                  marginBottom: 0
                  // margin: width < 600 ? "0" : "10rem"
                }}
                style={{
                  height: width > 600 ? "16vh" : "18vh"
                }}
              />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <ContactUs />
              <Banner
                // addLetterSpacing={width > 600}
                heading={"Travel With Us"}
                fontSize={joyBannerFontSize}
                renderIcons={true}
                renderFormButton={false}
                backgroundColor={"#97789B"}
                width={"100%"}
                style={{
                  alignSelf: "center",
                  height: width > 600 ? "16vh" : "14vh"
                }}
                headingStyle={{
                  marginBottom: 0
                }}
              />
            </>
          }
        />
        <Route
          path="/:destination/:subDestination"
          element={
            <>
              <ProductNew />
              <Banner
                headingStyle={{
                  marginBottom: 0
                }}
                heading={"Customize your journey with us"}
                // addLetterSpacing={width > 600}
                fontSize={joyBannerFontSize}
                renderIcons={true}
                width={"100%"}
                renderFormButton={true}
                style={{
                  height: width > 600 ? "16vh" : "18vh"
                }}
                backgroundColor={"#97789B"}
              />
            </>
          }
        />
        <Route path="/faq" element={<FAQ />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
